import api from './api';

// ─── Permission Roles ─────────────────────────────────────────────────────────

export const permissionRoleService = {
  getAll: () => api.get('/permission-roles'),
  getById: (id) => api.get(`/permission-roles/${id}`),
  create: (data) => api.post('/permission-roles', data),
  update: (id, data) => api.put(`/permission-roles/${id}`, data),
  delete: (id) => api.delete(`/permission-roles/${id}`),
};

// ─── Portal Users (staff) ─────────────────────────────────────────────────────

export const portalUserService = {
  getAll: () => api.get('/portal-users'),
  create: (data) => api.post('/portal-users', data),
  update: (id, data) => api.put(`/portal-users/${id}`, data),
  deactivate: (id) => api.delete(`/portal-users/${id}`),
  resetPassword: (id, new_password) => api.put(`/portal-users/${id}/password`, { new_password }),
};
